;( function ( $ ) {

    // the submit button of the comment reply form
    $( 'input[type="submit"]' ).addClass( 'btn btn-primary' );

    // position input image box
    // http://wordpress.org/support/topic/position-input-image-box#post-4953974
    $('p.form-allowed-tags').after( $('#comment-image-wrapper'));

} ( jQuery ) );

